import { Avatar, Divider, Menu, MenuItem } from '@material-ui/core';
import React, { MouseEventHandler, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import cdsConfig from '../styles/cds.config';
import { RiArrowDropDownFill } from 'react-icons/ri';
import { CLASSTING_URL } from '../../common/constants';

type UserInfo = {
  profileImage: string;
  role: string;
}

type UserMenuProps = {
  onSignOut: () => void;
  userInfo: UserInfo;
}

const MenuWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
`;

const StyledAvatarBox = styled.div<{open: boolean}>`
  display: inline-flex;
  line-height: 1;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-width: 4.5rem;
  height: 2.75rem;
  font-size: ${cdsConfig.fontSizes['size-80']};
  color: ${props => props.open ? cdsConfig.colors['ct-green-500'] : cdsConfig.colors['gray-600']};
`;

const StyledMenuIconBox = styled.span<{ open: boolean }>`
  transform: ${props => props.open ? 'rotate(180deg)' : 'rotate(0deg)'};
  font-size: ${cdsConfig.fontSizes['size-150']};
`;

const S = {
  MenuItem: styled(MenuItem)`
    width: 11.25rem;
    height: 3.5rem;
    color: ${cdsConfig.colors['text-dark']};
    font-size: ${cdsConfig.fontSizes['size-100']};
    padding: ${cdsConfig.space.$04};

    :hover {
      background-color: ${cdsConfig.colors['gray-100']};
    }
  `,
  Avatar: styled(Avatar)<{open: boolean}>`
    position: relative;
    width: 2.25rem;
    height: 2.25rem;
    font-size: ${cdsConfig.fontSizes['size-80']};

    &::after {
      position: absolute;
      display: block;
      content: ' ';
      top: 0;

      width: 100%;
      height: 100%;

      border-radius: inherit;
      box-shadow: inset 0 0 0 1px #2121211A;
    }

    &::after {
      border-radius: ${cdsConfig.radii.circle};
      box-shadow: ${props => props.open ? `inset 0 0 0 1px ${cdsConfig.colors['ct-green-500']}` : 'inset 0 0 0 1px #2121211A'};
    }
  `,
  Menu: styled(Menu)`
    .MuiList-padding {
      padding: 0;
    }
  `,
  Divider: styled(Divider)`
    border-top: 1px solid ${cdsConfig.colors['gray-200']}
  `,
};

const UserMenu = ({ onSignOut, userInfo }: UserMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClick: MouseEventHandler<HTMLDivElement> = ((event) => setAnchorEl(event?.currentTarget ?? null));
  const handleClose = () => setAnchorEl(null);
  const signOut = () => {
    handleClose();

    onSignOut();
  };

  return (
    <MenuWrapper>
      <StyledAvatarBox
        open={!!anchorEl}
        onClick={handleClick}
        aria-controls="member-menu"
        aria-haspopup="true"
      >
        <S.Avatar
          src={userInfo.profileImage}
          open={!!anchorEl}
          alt=""
        />
        <StyledMenuIconBox open={!!anchorEl}>
          <RiArrowDropDownFill />
        </StyledMenuIconBox>

      </StyledAvatarBox>
      <S.Menu
        id="member-menu"
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={!!anchorEl}
        onClose={handleClose}
      >
        <a href={CLASSTING_URL as string}>
          <S.MenuItem>
            홈으로 가기
          </S.MenuItem>
        </a>
        <S.Divider />
        <S.MenuItem onClick={signOut}>로그아웃</S.MenuItem>
      </S.Menu>
    </MenuWrapper>
  );
};

const mapUserMenuStateToProps = (state: any) => ({
  userInfo: state.user.info,
});

export default connect(
  mapUserMenuStateToProps,
)(UserMenu);
